/**
 * Returns the given function if `guard` is `true`. Otherwise returns `undefined`.
 *
 * @param func - A function to return
 * @param guard - A boolean to check if the function should be returned or not.
 */
export const guardedFunc = (func: () => void, guard: boolean): (() => void) | undefined => {
  if (!guard) return undefined;
  return func;
};
